import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _ConfigAdmin, _CostingCenter } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { _BusinessCore, _Project } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectBusinessCore = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {

    const { lista, setLista, instance } = useDataBean(_BusinessCore)
    const [id, setID] = useState(NaN);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(item => item.DataBeanProperties.IDBusinessCore == e);
            onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
        }
    };

    const getLista = () => {
        instance.getBusinessCoreCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <>
            <label>{label ?? "Core de Negocio"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBusinessCore} >{item.DataBeanProperties.Code} - {item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}